import WidgetTitle from './Title';

export default WidgetTitle;
